
import { css } from "@emotion/core";
import PulseLoader from "react-spinners/PulseLoader";
import styled from "styled-components";

const customCss = css`
  margin: 5px;
  text-align: center;
`;

const LoaderContainer = styled.div`
  padding: 20vh 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextLoader = (props) => {
  return (
    <div className="sweet-loading">
      <PulseLoader
        size={props.size || 8}
        color={props.color || "#2f394e"}
        loading={props.loading}
        css={customCss}
      />
    </div>
  );
};
const CommonComponentLoader = (props) => {
  return (
    <LoaderContainer>
      <TextLoader loading {...props} />
    </LoaderContainer>
  );
};

export default CommonComponentLoader;
